/**
 * @deprecated should use rolling button instead
 */
baseApp.directive('saveButton', function() {
	return {
		templateUrl: '/public/directives/saveButton.html',
		link: function($scope) {
		}
	}
});